import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../APIClient"; // Corrected path
import { ReservationQuestionDto } from "../generated/generatedTypes";

const fetchReservationQuestions = async (): Promise<ReservationQuestionDto[]> => {
  const response = await apiFetch("api/questions/reservation-flow"); // Endpoint path
  if (!response.ok) {
    throw new Error("Failed to fetch reservation questions from api/questions/reservation-flow");
  }
  const data = await response.json();
  return data as ReservationQuestionDto[];
};

export function useGetReservationQuestions() {
  return useQuery<ReservationQuestionDto[], Error>({
    queryKey: ["reservationQuestions"],
    queryFn: fetchReservationQuestions,
  });
}
